import React from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import { useAuth } from './AuthContext'

const PrivateRoutes = () => {

    const { currentUser } = useAuth()
    const navigate = useNavigate()

    useEffect(() => {
        if(!currentUser) {
            navigate('/client-login', {replace: true})
        }
    }, [])

    return (
        <>
            <Outlet />
        </>
    )
}

export default PrivateRoutes
